/**
 * Referral Form v1 — client-side schema.
 *
 * Mirrors configural-workspace-runtime/src/workspace/referral-schema.js.
 * Keep them in sync manually for v1; later a /api/workspace/schemas
 * endpoint will source-of-truth this from the DB.
 *
 * The client uses this schema to render inputs; the server uses its
 * copy to validate LLM tool args + check required-fields before submit.
 */

export const REFERRAL_FORM_V1 = {
  id: "referral-v1",
  name: "New Patient Referral",
  description: "Collect new-patient info before first visit.",
  sections: [
    {
      id: "patient",
      label: "About you",
      fields: [
        { id: "firstName", label: "First name", type: "text",  required: true },
        { id: "lastName",  label: "Last name",  type: "text",  required: true },
        { id: "dob",       label: "Date of birth", type: "date", required: true },
        { id: "phone",     label: "Phone number", type: "phone", required: true, placeholder: "(555) 555-5555" },
        { id: "email",     label: "Email",        type: "email", required: false },
      ],
    },
    {
      id: "insurance",
      label: "Insurance",
      fields: [
        { id: "insurance_carrier",   label: "Carrier",   type: "text", required: true },
        { id: "insurance_member_id", label: "Member ID", type: "text", required: false },
        { id: "insurance_group",     label: "Group number", type: "text", required: false },
      ],
    },
    {
      id: "referral",
      label: "Why you're being referred",
      fields: [
        { id: "referring_physician", label: "Referring physician", type: "text", required: true },
        { id: "referral_reason",     label: "Reason for referral", type: "textarea", required: true, rows: 3 },
        { id: "specialty_requested", label: "Specialty", type: "enum", required: true,
          options: ["Cardiology", "Oncology", "Orthopedics", "Neurology", "Other"] },
        { id: "urgency",             label: "Urgency", type: "enum", required: true,
          options: ["Routine", "Urgent"] },
      ],
    },
    {
      id: "medical",
      label: "Medical basics",
      fields: [
        { id: "current_medications", label: "Current medications", type: "list", required: false },
        { id: "allergies",           label: "Known allergies",     type: "list", required: false },
        { id: "pcp_name",            label: "Primary care physician", type: "text", required: false },
      ],
    },
  ],
};

export const SCHEMAS_BY_ID = {
  "referral-v1": REFERRAL_FORM_V1,
};

export function allFields(form) {
  return form.sections.flatMap((s) => s.fields);
}

export function countFilled(values, form) {
  const req = allFields(form).filter((f) => f.required);
  const filled = req.filter((f) => {
    const v = values?.[f.id];
    return v !== undefined && v !== null && v !== "" && !(Array.isArray(v) && v.length === 0);
  }).length;
  return { filled, required: req.length };
}
